/**
 * @description used to transform result from loadWallet Api of api-gateway
 * @api - /gateway-api/vault/loadWallet .
 *
 */
 import { payUPaymentRequestDTOTransformer } from '../payUPaymentRequestDTOTransformer';
 import { upiPaymentRequestDTOTransformer } from '../upiPaymentRequestDTOTransformer';
 import { razorpayRequestDTOTransformer } from '../razorpayRequestDTOTransformer';
 import { cashFreeRequestDTOTransformer } from '../cashFreeRequestDTOTransformer';
 import { cashFreeSeamlessDTOTransformer } from '../cashFreeSeamlessDTOTransformer';
 import { itemTransformer } from '../itemTransformer';
import { orderDataTransformer } from '../orderDataTransformer';

 interface ResponseType {
   items:object,
   cod_delay_message:string,
   is_new_user:boolean,
   status:string,
   paymentGateway:string,
   orderState:string,
   paytmRequestDTO:object,
   payUPaymentRequestDTO:object,
   paymentExtraParamsDTO: object,
   razorPayPaymentRequestDTO:object,
   refer_a_friend:string,
   shipping_address:object,
   upiPaymentRequestDTO:object,
   cashfreePaymentRequestDTO:object,
   cashfreeSeamlessPaymentRequestDTO:object,
   hashValue:string,
   bankcode:string,
   orderId: string,
   mode: string; 
   paymentInitiationRequestDTO?: object;
 }
 
// Data present in loadWalletResponse , but not used
//  "paymentId": 119816974,
//  "customerId": 16374551,
//  "amount": 1.0,
 export const loadWalletTransformer = (response: ResponseType) => {
   let transformedItems = itemTransformer(response.items || []);
 
 
   return {
    //  codDelayMessage: response.cod_delay_message || '',  // not in loadWalletResponse(used in PaymentSuccess-- not for wallet)
    //  isNewUser: response.is_new_user || -1,  // // not in loadWalletResponse(not in use)
    //  items: transformedItems,  // not in loadWalletResponse(used in PaymentSuccess & PreConfirmation-- not for wallet)
     orderData: orderDataTransformer(response || {}),
     paymentStatus: response.status || '', //(used in  doUpiPayment for upi timer)
     paymentGateway: response.paymentGateway || '', 
     orderStatus: response.orderState || '',
     paytmRequestDTO: response.paytmRequestDTO || {},
     payUPaymentRequestDTO: payUPaymentRequestDTOTransformer(
         response.payUPaymentRequestDTO || {},
       ),
     paymentExtraParamsDTO: response.paymentExtraParamsDTO || {},
     razorPayPaymentRequestDTO: razorpayRequestDTOTransformer(response.razorPayPaymentRequestDTO || {}),
    //  referAFriend: response.refer_a_friend || {},   // not in loadWalletResponse(not in use && not in any mock)
     shippingAddress: response.shipping_address || {}, // not in loadWalletResponse (need not to use in wallet money, but adding because of breaking in buildRequestParams)
     upiPaymentRequestDTO: upiPaymentRequestDTOTransformer(response.upiPaymentRequestDTO || {}),
     cashfreePaymentRequestDTO: cashFreeRequestDTOTransformer(response.cashfreePaymentRequestDTO || {}),
     cashfreeSeamlessPaymentRequestDTO: cashFreeSeamlessDTOTransformer(response.cashfreeSeamlessPaymentRequestDTO || {}),
     paymentInitiationRequestDTO:response?.paymentInitiationRequestDTO
    //  hashValue: response.hashValue || '', // not in loadWalletResponse(used for  PaymentSuccess incase of guest users)
   };
 };
